const actionTypes = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  SELECT: 'SELECT'
  //Add more constants here....
};

export default actionTypes;
